export default "__VITE_ASSET__CWIsx6b8__"